"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SigmaModelEntryFormDefinition = exports.SigmaModelEntryFormOutputSchema = exports.SigmaModelEntryFormInputSchema = void 0;
const z = require("zod");
const form_types_1 = require("../../../../Datatypes/form.types");
const form_schemas_1 = require("./form-schemas");
const payload_1 = require("./payload");
exports.SigmaModelEntryFormInputSchema = payload_1.SigmaModelEntryFormPayloadSchema.extend({
    datasheetFileId: z.string(),
    manufacturerPartNumber: z.string(),
});
exports.SigmaModelEntryFormOutputSchema = payload_1.SigmaModelEntryFormPayloadSchema.extend({
    sigmaModelType: z.string().min(1, 'sigmaModelType is required'),
    formBailout: form_types_1.FormBailoutSchema,
    rawFormData: form_schemas_1.SigmaModelEntryFormDataSchema.optional().catch(undefined),
});
exports.SigmaModelEntryFormDefinition = {
    type: 'SigmaModelEntryForm',
    displayName: 'Sigma Model Entry Form',
    inputSchema: exports.SigmaModelEntryFormInputSchema,
    outputSchema: exports.SigmaModelEntryFormOutputSchema,
};
//# sourceMappingURL=step-definition.js.map